import { Component, inject, signal, WritableSignal } from '@angular/core';
import { UploadProgression } from "../upload-progression/upload-progression";
import { ContentPreview } from "../../components/content-creation-preview/content-preview";
import { ColorService } from '../../services/color.service';
import { IconComponent } from "@kinomap-dev/ng-ui-lib/basics";
import { MediaBlockService } from '../../services/media-block-service';
import { CreateContentService } from '../../services/create-content.service';
import { UploadService } from '../../services/upload-service';
import { ContentType } from '../content-creation/content-creation';
import { RouterLink } from "@angular/router";
import { AnalyticsService } from '../../services/analytics.service';

import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-upload-layout',
  imports: [TranslateModule, UploadProgression, ContentPreview, IconComponent, RouterLink],
  templateUrl: './upload-layout.html',
  styleUrl: './upload-layout.scss',
})
export class UploadLayout {
  uploadComplete: WritableSignal<boolean> = signal(false);
  public colorService: ColorService = inject(ColorService);
  private createContentService: CreateContentService = inject(CreateContentService);
  private mediaBlockService: MediaBlockService = inject(MediaBlockService);
  private uploadService: UploadService = inject(UploadService);
  private analyticsService: AnalyticsService = inject(AnalyticsService);

  onUploadComplete(): void {
    this.analyticsService.track('upload_complete', {
      content_type: this.createContentService.contentType(),
    });
    this.uploadComplete.set(true);
  }

  clearDataStored(): void {
    const contentType: ContentType | undefined = this.mediaBlockService.contentType
    if (!contentType) {
      console.error('pas de content type')
      return
    }
    localStorage.removeItem(contentType + '_form');
  }

  ngOnInit(): void {
    this.clearDataStored()
  }

  private clearUploadData(): void {
    this.clearDataStored()
    this.createContentService.reset();
    this.mediaBlockService.reset();
    this.uploadService.reset();

  }

  ngOnDestroy(): void {
    this.clearUploadData();
  }
}
